import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'

import PageTitle from 'components/atoms/PageTitle'
import UsersContent from 'components/organisms/Users/UsersContent'
import {
  USERS_LIST_TYPE_ARVAL_USERS,
  USERS_LIST_TYPE_PARTNERS,
  USERS_LIST_TYPE_PARTNER_USERS,
} from 'components/organisms/Users/usersLib'

import {
  ROLES_ARVAL,
  ROLE_ADMIN,
  ROLE_B2C,
  ROLE_LOGISTICS,
  ROLE_POST_SALES,
  ROLE_READ_ONLY,
  ROLE_SUPER_ADMIN,
  useAuth,
} from '../../auth'

export default function Users() {
  const { t } = useTranslation()
  const { hasOneOfRoles } = useAuth()
  const canAccess = useMemo(() => hasOneOfRoles(ROLES_ARVAL), [hasOneOfRoles])
  const userRoleHasReadOnly = useMemo(
    () =>
      hasOneOfRoles([
        ROLE_READ_ONLY,
        ROLE_LOGISTICS,
        ROLE_B2C,
        ROLE_POST_SALES,
      ]),
    [hasOneOfRoles]
  )

  if (!canAccess) {
    return <Navigate to="/agenda" />
  }

  return (
    <div className="content-container">
      <PageTitle label={t('users.title')} />

      {hasOneOfRoles([ROLE_SUPER_ADMIN]) && (
        <UsersContent
          enabledListTypes={[
            USERS_LIST_TYPE_ARVAL_USERS,
            USERS_LIST_TYPE_PARTNERS,
          ]}
          defaultType={USERS_LIST_TYPE_ARVAL_USERS}
          date-testid="users-air-view"
          contentIsReadOnly={userRoleHasReadOnly}
        />
      )}
      {hasOneOfRoles([
        ROLE_ADMIN,
        ROLE_READ_ONLY,
        ROLE_LOGISTICS,
        ROLE_B2C,
      ]) && (
        <UsersContent
          enabledListTypes={[USERS_LIST_TYPE_PARTNER_USERS]}
          defaultType={USERS_LIST_TYPE_PARTNER_USERS}
          date-testid="users-arval-view"
          contentIsReadOnly={userRoleHasReadOnly}
        />
      )}
    </div>
  )
}
